import React from "react";
import Section from "./Section";
import img1 from "../images/img1.png";
import img3 from "../images/img3.png";
import img2 from "../images/img2.jpeg";
import img4 from "../images/img4.png";
import { Link } from "react-router-dom";

const Sections = ({ color, ref }) => {
  const data = [
    {
      heading: "Fearless Self-Expression",
      desc: "Embrace your true self without fear of judgment. Share your thoughts, ideas, and creativity openly and anonymously, fostering a community built on freedom of expression.",
      img: img1,
      isReverse: true,
    },
    {
      heading: "Virtual AI Friend",
      desc: "Experience virtual companionship on your terms. Interact with customizable 3D avatars, engaging in conversations and sharing emotions in a secure environment, without the need to disclose personal details.",
      img: img2,
      isReverse: false,
    },

    {
      heading: "Random Chat",
      desc: "Connect with people from all walks of life through our dynamic random chat feature. Discover new perspectives, engage in spontaneous conversations, and make exciting connections with individuals who share your interests.",
      img: img3,
      isReverse: true,
    },
    {
      heading: "Secure & Safe",
      desc: "Connections: Enjoy a safe and private social networking experience. Connect with others while maintaining complete control over your personal information and identity, with robust privacy measures in place.",
      img: img4,
      isReverse: false,
    },
  ];
  return (
    <div id="about" className="base-wrapper flex flex-col md:mt-0 mt-[100px]">
      <div className="text-[#fff] mx-auto text-center text-[28px] md:text-[52px] font-[700] mt-[60px]">
        Why should you use Introverse ?
      </div>
      {data.map((e) => {
        return (
          <Section
            isReverse={e.isReverse}
            description={e.desc}
            heading={e.heading}
            img={e.img}
            key={e}
            color={color}
          />
        );
      })}
      <div className="text-[22px] text-center font-[600] mt-[0px]">
        and much more.......
      </div>
      <Link to="/join" className="btn mt-[100px] mx-auto">
        Join now
      </Link>
    </div>
  );
};

export default Sections;
